export class MenuItemCapacity {
  id: number;
  hotel_id: number;
  menu_item_id: number;
  no: string;
  location: string;
  description: string;
  capacity: number;
  adult_capacity: number;
  status: boolean;
}
